import {
  InnerMediaBlock,
  InnerMediaBlockProps,
  PluginButtonProps,
} from '@prismamedia/one-components';
import { FC } from 'react';
import { MultimediaPluginButton } from './MultimediaPluginButton';

interface ImageSourceCategory {
  id: string;
  imageSources?: { id: string; title: string }[];
  sources?: { id: string; title: string }[];
  title: string;
}

type FetchSources = (
  search: string,
) => Promise<ImageSourceCategory[] | undefined>;

interface MultimediaPluginProps {
  fetchSources?: FetchSources;
  withErrors?: boolean;
}

interface MultimediaPlugin {
  (props: MultimediaPluginProps): {
    type: 'media';
    buttonComponent: FC<PluginButtonProps>;
    blockComponent: FC<InnerMediaBlockProps>;
  };
}

export const MultimediaPlugin: MultimediaPlugin = (props) => ({
  type: 'media',
  buttonComponent: MultimediaPluginButton,
  blockComponent: InnerMediaBlock,
  options: {
    fetchSources: props.fetchSources,
    fieldsRequired: true,
    withErrors: props.withErrors,
  },
});
